import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Control } from '../../../models/control';
import { ConfigureHoursDialog } from './dialogs/configure-hours/configure-hours.dialog';
import { EditInfoDialog } from './dialogs/edit-info/edit-info.dialog';

import { DeleteWorkshopDialog } from './dialogs/delete-workshop/delete-workshop.dialog';
import { LockSettingsDialog } from './dialogs/lock-settings/lock-settings.dialog';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { Workshop } from 'src/models/workshop';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';
import { Brand } from 'src/models/brand';
import { finalize, Observable, tap, reduce, map, forkJoin, catchError, throwError } from 'rxjs';
import { MatPaginatorIntl as MatPaginatorIntl, PageEvent as PageEvent } from '@angular/material/paginator';
import { CustomPaginator } from '../CustomPaginatorConfiguration';
import { HelperService } from 'src/services/helperService';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { APIService } from 'src/services/api-services/api-service';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { city } from 'src/services/api-services/api-interfaces/city.interface';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user';
import { APIchiefWorkshopService } from 'src/services/api-services/api-chiefWorkshop';
import { chiefWorkshop } from 'src/services/api-services/api-interfaces/chiefWorkshop';

@Component({
    selector: 'app-workshops',
    templateUrl: './workshops.component.html',
    styleUrls: ['./workshops.component.sass'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: MatPaginatorIntl, useValue: CustomPaginator() }],
    standalone: false
})
export class WorkshopsComponent implements OnInit {
  onAddControlClick = (param: string): void => {};
  user: User = this.helperService.user;
  id = this.user.retailId ? this.user.retailId : this.user.workshopId;
  setClickedBrand(brand: any) {
    this.brandNameFilter = brand.brandName;
  }
  pagesize: number = 16;
  desde: number = 0;
  hasta: number = 16;
  pagesCount: number = 0;
  selectedPage: number = 0;
  rowPerPage: number = 16;
  workshopsData: Workshop[] = [];
  userRoleOptional?: number;
  filterByWorkshopName: string = '';
  filterByCity: string = '';
  filterByAddress: string = '';
  filterByChiefOfWorkshop: string = '';
  generalfilter: string = '';
  brandNameFilter: string = '';
  workshopsForDialog: Workshop[] = [];
  brands: brands[] = [];
  brandsforDialog: brands[] = [];
  chiefsForDialog: chiefWorkshop[] = [];
  citiesForDialog: city[] = [];
  typesOfServiceForDialog: typeOfService[] = [];
  brands$ = new Observable<brands[]>();
  cities$ = new Observable<city[]>();
  typesOfService$ = new Observable<typeOfService[]>();
  chiefsOfWorkshop$ = new Observable<chiefWorkshop[]>();
  workshops$: Observable<Workshop[]> = new Observable<Workshop[]>();

  workshops: Workshop[] = [];
  paginatorLength: number = 0;
  editionRequiredInformation$ = new Observable<
    [Workshop[], brands[], chiefWorkshop[], city[], typeOfService[]]
  >();
  controls: Control[] = [
    {
      icon: 'bi bi-plus-lg',
      description: 'Add Workshops',
      action: this.onAddControlClick,
    },
  ];

  constructor(
    public helperService: HelperService,
    public dialog: MatDialog,
    public WorkshopService: APIWorkshopService,
    public brandsService: APIBrandsService,
    public cityServiceApi: APIcityService,
    public Service: APIService,
    public APIchiefWorkshopService: APIchiefWorkshopService,
    public typesOfServiceService: APIService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.desde = 0
    this.hasta = this.pagesize
    if (this.helperService.user.role.roleId === 4) {
      this.id = this.helperService.user.retailId;
    } else {
      this.id = this.helperService.user.workshopId;
    }
    this.helperService.TitlePage = 'AdminWorkshops'
    console.log(this.helperService.TitlePage);
    this.workshops$ = this.WorkshopService?.getManagement(
      this.user.role.roleId,
      this.id
    ).pipe(
      tap((workshops) => {
        this.workshopsForDialog = workshops;
        this.paginatorLength = workshops.length;
        const brandMap = new Map<string, any>();
        workshops.forEach((workshop) => {
          workshop.brands.forEach((brand) => {
            const key = `${brand.brandName}-${brand.brandId}`;
            brandMap.set(key, brand);
          });
        });
        this.brands = Array.from(brandMap.values());
      }),
      catchError((error) => {
        // Manejo de error 401
        if (error.status === 401) {
          this.helperService.logoutToken();
        }

        return throwError(() => error);
      })
    );
    this.brands$ = this.brandsService
      .get('')
      .pipe(tap((brands) => (this.brandsforDialog = brands)));
    this.chiefsOfWorkshop$ = this.APIchiefWorkshopService.get('').pipe(
      tap((chiefsOfWorkshop) => {
        this.chiefsForDialog = chiefsOfWorkshop;
      })
    );
    this.cities$ = this.cityServiceApi
      .getForCountry(String(this.helperService.user.countryId))
      .pipe(
        tap((cities) => {
          this.citiesForDialog = cities;
        })
      );
    this.typesOfService$ = this.typesOfServiceService.get('').pipe(
      tap((typesOfService) => {
        this.typesOfServiceForDialog = typesOfService;
      })
    );

    this.editionRequiredInformation$ = forkJoin([
      this.workshops$,
      this.brands$,
      this.chiefsOfWorkshop$,
      this.cities$,
      this.typesOfService$,
    ]);
    this.helperService.icon = "edit"
    if (this.user.role.roleId === 4) {
      this.userRoleOptional = this.user.retailId;
    }
    if (this.user.role.roleId === 2) {
      this.userRoleOptional = this.user.workshopId;
    }
    this.workshopsData = [];
  }

  changePage(e: PageEvent) {
    this.desde = e.pageIndex * e.pageSize;
    this.hasta = this.desde + e.pageSize;
  }
  // Function show icons hover

  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

  // Function Change state workshop

  ChangeState(workshop: Workshop) {
    let translateText = ''
    if (workshop.email === '') {
      workshop.email = workshop.workshopName + '@';
    }
    if (workshop.isActive === true) {
      workshop.state = false;
        translateText = this.translate.instant(
          'ToastWorkshopDisabled',
          {
            fullName:workshop.workshopName,
          }
        );

    } else {
      workshop.state = true;
        translateText = this.translate.instant(
          'ToastWorkshopEnabled',
          {
            fullName:workshop.workshopName,
          }
        );

    }
    this.WorkshopService?.put(workshop)
      .pipe(tap(() => {this.ngOnInit()
        this.helperService.showAlert =true
        this.helperService.typeAlert ="success"
        this.helperService.messageAlert =translateText

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
      }
    ))
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  // Functions to open workshop dialogs

  onEditInformationClick(workshop?: Workshop) {
    const requiredInfo = {
      workshop,
      workshopRequiredInfo: [
        this.workshopsForDialog,
        this.brandsforDialog,
        this.chiefsForDialog,
        this.citiesForDialog,
        this.typesOfServiceForDialog,
      ],
    };

    const dialogRef = this.dialog.open(EditInfoDialog, {
      width: '608px',
      panelClass: 'icon-outside',
      data: requiredInfo,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }

  onConfigureHoursClick(workshop: Workshop) {
    if (workshop.isActive) {
      const dialogRef = this.dialog.open(ConfigureHoursDialog, {
        width: '1000px',
        panelClass: 'icon-outside',
        data: workshop,
      });
      dialogRef.afterClosed().subscribe((result) => {});
    } else {
      const translateText = this.translate.instant('ToastDesactiveWorkshop', {
        fullName: workshop.workshopName,
      });
            this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
            this.helperService.messageAlert =translateText
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
    }
  }

  onDeleteWorkshopClick(workshop: Workshop) {
    const dialogRef = this.dialog.open(DeleteWorkshopDialog, {
      width: '600px',
      panelClass: 'icon-outside',
      data: workshop,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'DeleteData') {
      }
    });
  }

  onLockSettingsClick(workshop: Workshop) {
    if (workshop.isActive) {
      const dialogRef = this.dialog.open(LockSettingsDialog, {
        panelClass: 'icon-outside',
        data: workshop,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
      });
    } else {
      const translateText = this.translate.instant('ToastDesactiveWorkshop', {
        fullName: workshop.workshopName,
      });
            this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
            this.helperService.messageAlert =translateText

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
    }
  }
}
